import type { Folder } from '~/types/folders'

export function useFolder() {
  const { sortByNumberName } = useUtils()

  const sortTemplateFolders = (folders: any[]) => {
    return folders.sort((a, b) => {
      const isNumA = /^\d+(\.\d+)?$/.test(a)
      const isNumB = /^\d+(\.\d+)?$/.test(b)

      if (isNumA && isNumB) {
        // Both are numbers - compare numerically
        return Number(a) - Number(b)
      }
      if (isNumA) {
        // Only A is a number - put A first
        return -1
      }
      if (isNumB) {
        // Only B is a number - put B first
        return 1
      }
      // Neither are numbers - compare alphabetically
      return a.localeCompare(b)
    })
  }
  const getFolderType = async (type: string, businessId: string) => {
    console.log('TYPE:', type)
    const res = await $fetch(`/api/v1/folders/types`, {
      method: 'GET',
      params: {
        type: type,
        businessId: businessId,
      },
    })
    return res
  }

  const getAllFolders = async (businessId: string, parentFolderId?: string | null) => {
    const params: any = {
      businessId: businessId,
    }

    if (parentFolderId !== undefined) {
      params.parentFolderId = parentFolderId || 'null'
    }

    const res = await $fetch(`/api/v1/folders`, {
      method: 'GET',
      params: params,
    })

    const newData = sortByNumberName(res?.data, 'name')

    console.log('NEW DATA:', newData)

    res.data = newData

    return res
  }

  const getVdrTree = async (businessId: string) => {
    const res = await $fetch('/api/v1/folders/vdr-tree', {
      method: 'GET',
      params: { businessId },
    }) as {
      statusMessage: string
      data: Folder[]
    }
    return res
  }

  const createFolder = async (body) => {
    const res = await $fetch(`/api/v1/folders/create`, {
      method: 'POST',
      body: body,
    })
    return res
  }

  const getFolderById = async (folderId: string) => {
    const res = await $fetch(`/api/v1/folders/${folderId}`, {
      method: 'GET',
    })

    return res
  }

  const getFolderByTypeAndBusinessId = async (type: string, businessId: string) => {
    const res = await $fetch(`/api/v1/folders`, {
      method: 'GET',
      params: {
        type: 'filter',
        folderType: type,
        businessId: businessId,
      },
    })

    return res
  }
  const updateFolder = async (body) => {
    const res = await $fetch(`/api/v1/folders/${body.id}`, {
      method: 'PUT',
      body: body,
    })
    return res
  }

  const deleteFolder = async (folderId: string) => {
    const res = await $fetch(`/api/v1/folders/${folderId}`, {
      method: 'DELETE',
    })
    return res
  }

  return {
    getFolderType,
    getFolderById,
    getAllFolders,
    getVdrTree,
    createFolder,
    updateFolder,
    deleteFolder,
    getFolderByTypeAndBusinessId,
    sortTemplateFolders,
  }
}
